import React from 'react'
import {withRouter} from 'react-router'
import {default as i18n, lang, TitleDescription} from '../utils/i18n'
import Avatar from 'material-ui/Avatar'
import Grid from 'material-ui/Grid'
import '../layouts/subpage.scss'
import './staff/staff.scss'

export default withRouter(function Staff ({ location, data }) {
  const ln = lang(location)
  const members = data.allStaff.edges[0].node.staffs

  return (
    <div lang={ln}>
      <TitleDescription texts={{
        en: {
          title: 'Committee members',
          desc: 'Committee members of DroidKaigi 2018'
        },
        ja: {
          title: '運営スタッフ',
          desc: 'DroidKaigi 2018 運営スタッフを紹介します。'
        }
      }} />
      <div className='subpage-title-wrapper bg-gray2'>
        <h2 className='text-yellow1'><Text id='title' /></h2>
      </div>
      <div className='subpage-container'>
        <StaffList members={members} />
      </div>
    </div>
  )
})

class StaffList extends React.Component {
  render () {
    const { members } = this.props
    return (
      <Grid container className='memberList'>
        {members.map(member =>
          <Grid item xs={3} sm={2} md={1}>
            <a href={member.href}>
              <Avatar className='memberList--avatar'
                alt={member.name}
                src={member.image}
              />
              {member.name}
            </a>
          </Grid>
        )}
      </Grid>
    )
  }
}

const Text = i18n({
  en: {
    title: 'Committee members'
  },
  ja: {
    title: '運営スタッフ'
  }
})

export const pageQuery = graphql`
query StaffsQuery {
  allStaff {
    edges {
      node {
        staffs {
          name
          name_en
          href
          image
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/staff.js